// initial state
const state = {
  progress: [],
  loading: []
}
// getters
const getters = {
  progress: state => state.progress,
  loading: state => state.loading,
}

// actions
const actions = {
  background({ commit }, promise) {
    commit('addToQueue', { key: 'loading', promise })
  },
  queue({ commit }, promise) {
    commit('addToQueue', { key: 'progress', promise })
  }
}

// mutations
const mutations = {
  addToQueue(state, data) {
    state[data.key].push(data.promise)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
